import { TAppState } from '../../types/appState';

export function feedbackChatbotModalSelector(state: TAppState) {
  return state.feedbackChatbotModal;
}
